export default "__VITE_ASSET__BZLlwxEY__"